import React, { ComponentType, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import type { UserState } from 'state/userSlice';
import { getDashboardHomePath, isAdministrationToolkitPath } from 'config/loginPortals';

/*
  Gates AdministrationTools behind the admin flag already loaded at login.
  Avoids an extra users round-trip when the toolkit mounts.
 */
const withAdminCheck = <P extends object>(
  WrappedComponent: ComponentType<P>,
) => {
  return (props: P) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAdmin = useSelector(
      (state: { user: UserState }) => state.user.admin,
    );

    useEffect(() => {
      if (!isAdmin && isAdministrationToolkitPath(location.pathname)) {
        navigate(getDashboardHomePath(location.pathname));
      }
    }, [isAdmin, location.pathname, navigate]);

    return isAdmin ? <WrappedComponent {...props} /> : null;
  };
};

export default withAdminCheck;
